
















import Vue from 'vue';

export default Vue.extend({
  name: 'MStoreRadioButtonGroup',
  props: {
    id: {
      type: String
    },
    value: {
      required: true
    },
    options: {
      required: true,
      type: Array
    },
    valueField: {
      default: 'value',
      type: String
    },
    textField: {
      default: 'text',
      type: String
    },
    state: {
      default: null
    }
  },
  computed: {
    inputValue: {
      get(this: any) {
        return this.value;
      },
      set(value: any) {
        this.$emit('input', value);
      }
    }
  }
});
